import React, { useState } from "react";
import { Modal } from "semantic-ui-react";

const withModal = (WrappedComponent, TriggerComponent) => {
  return function ({ triggerProps, modalProps, ...rest }) {
    const [open, setOpen] = useState(false);
    const { header, ...restModalProps } = modalProps;
    return (
      <Modal
        trigger={
          <TriggerComponent onClick={() => setOpen(true)} {...triggerProps} />
        }
        closeIcon
        open={open}
        onClose={() => setOpen(false)}
        closeOnDimmerClick={false}
        {...restModalProps}
      >
        {header && <Modal.Header content={header} />}
        <Modal.Content>
          <WrappedComponent closeModal={() => setOpen(false)} {...rest} />
        </Modal.Content>
      </Modal>
    );
  };
};

export default withModal;
